import { __rest } from "tslib";
import * as React from 'react';
import ProductNav from './navigation';
import { StyledProductContent, StyledProductFrame, StyledProductNav, } from './ProductFrame.styled';
export const ProductFrame = (_a) => {
    var { navigation, subnavigation, menu, children } = _a, otherProps = __rest(_a, ["navigation", "subnavigation", "menu", "children"]);
    return (React.createElement(StyledProductFrame, Object.assign({}, otherProps),
        React.createElement(StyledProductNav, null,
            React.createElement(ProductNav, { navigation: navigation, menu: menu, subnavigation: subnavigation || [] })),
        React.createElement(StyledProductContent, { id: "product-content" }, children)));
};
//# sourceMappingURL=ProductFrame.js.map